import React from 'react';

import { Badge, Box, Center, Flex, Text, Switch } from '@chakra-ui/react';

const Statuses = () => {
  return (
    <Box borderRadius="xl">
      <Box
        px={3}
        backgroundColor="transparent"
        mx={3}
        // my={3}
        py={2}
      >
        <Flex justifyContent="space-between">
          <Box display="flex" justifyContent="center" alignItems="center">
            <Text color="#FFF" fontSize={12} ps={2} fontWeight={500}>
              DND
            </Text>
          </Box>
          <Box>
            <Badge
              backgroundColor="transparent"
              // borderRadius={30}
              color="white"
              borderRadius="full"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Switch
                //    isChecked={isDnd}
                //      onChange={handleChange}
                //  isDisabled={loading}
                colorScheme="red"
              />
            </Badge>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};

export default Statuses;
